   import Khasara from "../components/configuration/khasara/Khasara";

const KhasaraPage = () => {
    return (
                <Khasara />
    )
}   
export default KhasaraPage;
